import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faTruck, 
  faSyncAlt, 
  faColumns, 
  faWindowRestore, 
  faRedo,
  faCompress,
  faExpand,
  faDownload,
  faSearchMinus,
  faKeyboard,
  faLink,
  faUnlink,
  faPlus
} from '@fortawesome/free-solid-svg-icons';
import splitScreenManager, { SPLIT_MODES } from '../../../utils/SplitScreenManager';
import chartSyncManager from '../../../utils/ChartSyncManager';

const ChartControls = ({
  title,
  vehicle,
  expandedMode,
  showKeyboardShortcuts,
  onRefresh,
  onToggleExpanded,
  onToggleKeyboardShortcuts,
  onResetZoom,
  onExportChart,
  onHorizontalSplit,
  onVerticalSplit,
  onToggleSyncMode,
  onShowReportChooser
}) => {
  return (
    <div className="tm-header">
      <div className="tm-title">
        <FontAwesomeIcon icon={faTruck} style={{ marginRight: '8px' }} /> 
        <span>{title} {vehicle && vehicle.name ? `- ${vehicle.name}` : ''}</span>
      </div>
      <div className="tm-controls">
        <div className="tm-control-group">
          <button
            className="tm-control-button"
            onClick={onResetZoom}
            title="Сбросить увеличение (Esc, Пробел или Ctrl+0)"
          >
            <FontAwesomeIcon icon={faSearchMinus} />
          </button>
          <button
            className="tm-control-button"
            onClick={onToggleKeyboardShortcuts}
            title="Показать горячие клавиши"
          >
            <FontAwesomeIcon icon={faKeyboard} />
          </button>
          <button
            className="tm-control-button"
            onClick={onRefresh}
            title="Обновить данные"
          >
            <FontAwesomeIcon icon={faSyncAlt} />
          </button>
        </div>
        
        {/* Группа кнопок разделения экрана */}
        <div className="tm-control-group">
          
          <button
            className="tm-control-button"
            onClick={onHorizontalSplit}
            title="Разделить по горизонтали"
          >
            <FontAwesomeIcon icon={faColumns} style={{ transform: 'rotate(90deg)' }} />
          </button>
          <button
            className="tm-control-button"
            onClick={onVerticalSplit}
            title="Разделить по вертикали"
          >
            <FontAwesomeIcon icon={faColumns} />
          </button>
          <button
            className="tm-control-button"
            onClick={() => splitScreenManager.changeSplitMode(SPLIT_MODES.SINGLE)}
            title="Один экран"
          >
            <FontAwesomeIcon icon={faWindowRestore} />
          </button>
          <button
            className="tm-control-button"
            onClick={() => splitScreenManager.goBack()}
            title="Вернуться к предыдущему режиму"
          >
            <FontAwesomeIcon icon={faRedo} style={{ transform: 'rotate(180deg)' }} />
          </button>
        </div>
        
        <div className="tm-control-group">
          <button
            className="tm-control-button"
            onClick={onExportChart}
            title="Скачать изображение"
          >
            <FontAwesomeIcon icon={faDownload} />
          </button>
        </div>
        <div className="tm-control-group">
          <button
            className="tm-control-button"
            onClick={onToggleExpanded}
            title={expandedMode ? "Свернуть" : "На весь экран"}
          >
            <FontAwesomeIcon icon={expandedMode ? faCompress : faExpand} />
          </button>
        </div>
        <div className="tm-control-group">
          <button
            className={`tm-control-button ${chartSyncManager.syncEnabled ? 'sync-active' : 'sync-inactive'}`}
            onClick={onToggleSyncMode}
            title="Включить/выключить синхронизацию масштабирования между графиками"
          >
            <FontAwesomeIcon icon={chartSyncManager.syncEnabled ? faLink : faUnlink} />
          </button>
        </div>
      </div>
      
      {showKeyboardShortcuts && (
        <div className="keyboard-shortcuts-tooltip" 
             style={{
               position: 'absolute',
               top: '50px',
               right: '10px',
               background: 'rgba(0, 0, 0, 0.8)',
               color: 'white',
               padding: '10px',
               borderRadius: '5px',
               zIndex: 1000,
               fontSize: '12px',
               boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)'
             }}>
          <div style={{fontWeight: 'bold', marginBottom: '5px'}}>Горячие клавиши:</div>
          <div>Esc - сбросить масштаб</div>
          <div>Пробел - сбросить масштаб</div>
          <div>Ctrl+0 - сбросить масштаб</div>
          <div>Shift+прокрутка - перемещение по графику</div>
          <div>Колесо мыши - изменение масштаба</div>
          <div style={{marginTop: '5px', fontWeight: 'bold', borderTop: '1px solid rgba(255,255,255,0.2)', paddingTop: '5px'}}>Синхронизация:</div>
          <div>Масштабирование синхронизировано между всеми графиками</div>
          <div>Используйте кнопку <FontAwesomeIcon icon={chartSyncManager.syncEnabled ? faLink : faUnlink} /> для включения/выключения</div>
          <div style={{marginTop: '5px', textAlign: 'center'}}>
            <button onClick={onToggleKeyboardShortcuts} 
                    style={{background: 'transparent', border: '1px solid white', color: 'white', padding: '2px 5px', cursor: 'pointer'}}>
              Закрыть
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChartControls; 